import { API_BASE_URL } from '../constants';
import { RepairService } from '../types/BookingTypes';

const CDN_BASE_URL = 'https://admin.mintomein.in/public/uploads/';

export const getPopularServices = async (): Promise<RepairService[]> => {
  const response = await fetch(`${API_BASE_URL}/model/popular`, {
    method: 'GET',
    headers: { accept: 'application/json' },
  });

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

  const data = await response.json();
  if (!data.isSuccess) throw new Error(data.message || 'Failed to fetch popular services');

  return (data.entity as any[]).map((s) => ({
    id: s.id,
    makeId: s.makeId,
    modelId: s.modelId,
    modelName: s.modelName ?? '',
    makeName: s.makeName ?? '',
    serviceName: s.serviceName,
    serviceImage: s.serviceImage
      ? s.serviceImage.startsWith('http')
        ? s.serviceImage
        : `${CDN_BASE_URL}${s.serviceImage}`
      : '',
    modelImage: s.modelImage
      ? s.modelImage.startsWith('http')
        ? s.modelImage
        : `${CDN_BASE_URL}${s.modelImage}`
      : null,
    actualPrice: s.actualPrice,
    markedPrice: s.markedPrice,
    serviceDuration: s.serviceDuration,
    serviceCost: s.serviceCost,
    serviceImagePath: s.serviceImagePath ?? null,
    modelImagePath: s.modelImagePath ?? null,
    warrantyTypeId: s.warrantyTypeId ?? 1,
    warrantyName: s.warrantyName ?? '',
    warrantyTypeDescription: s.warrantyTypeDescription ?? '',
    warrantyCoveredItems: s.warrantyCoveredItems ?? '',
    warrantyNotCoveredItems: s.warrantyNotCoveredItems ?? '',
    warrantyPeriod: s.warrantyPeriod ?? 0,
    serviceImageBytes: null,
    finalPrice: s.finalPrice ?? 0,
  }));
};
